import React from "react";
import Navigation from "../../components/landing/Navigation";
import Bottomer from "../../components/landing/Bottomer";
import ITGUY from "../../assets/ITGUY.png";
import { Button } from "@mui/material";
import Sick from "../../assets/sickIT.png";
import { ArrowDropDownCircleOutlined } from "@mui/icons-material";

function Getapp() {
  return (
    <div className="flex flex-col">
      <Navigation link={"getapp"} title="Download Levitra App" />
      <div className="pb-[7rem] pt-[10rem] items-center flex justify-center gap-20">
        <div className="flex max-w-[20rem] flex-col gap-5">
          <div className="text-5xl max-w-[15rem] font-bold">
            Levitra for windows
          </div>
          <div className="text-xl leading-7 text-[#000000B2] font-semibold">
            Levitra is a health-care based on chat system to help people
            maintain their health
          </div>
          <Button sx={{ background: "#10398A" }} variant="contained">
            Dowload App
          </Button>
          <div className="text-[#0343C0] font-semibold text-lg w-fit border-b-2 border-[#0343C0]">
            Download on Microsoft Store
          </div>
          <div className="flex items-center font-medium cursor-pointer gap-1">
            <div>Looking for mobile ?</div>
            <ArrowDropDownCircleOutlined />
          </div>
        </div>
        <img src={ITGUY} className="max-w-[45vw] 2xl:max-w-[40rem]" />
      </div>
      <div className="flex mb-[7rem] gap-3 items-center bg-[#152A74] text-white py-10 justify-center">
        <div className="flex flex-col max-w-[25rem] gap-7">
          <div className="font-bold text-5xl">Stay with us from anywhere</div>
          <div className="text-xl">
            Get in touch in with doctors with the Levitra apps for{" "}
            <a className="text-blue-400 cursor-pointer">Android</a> and{" "}
            <a className="text-blue-400 cursor-pointer">iOS</a>
          </div>
        </div>
        <img src={Sick} className="2xl:max-w-[30rem] max-w-[45vw]" />
      </div>
      <Bottomer />
    </div>
  );
}

export default Getapp;
